import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useSaveCustomFieldDefinition = function () {
    return useApiCall(function (signal, payload) { return api.customFields.apiCustomFieldDefinitionPost(payload, { signal: signal }); }, null, true, [], { success: 'Custom field saved.' });
};
